/*
 * @Author: Jordan
 * @Date: 2019-08-27 20:32:23
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2020-08-05 10:23:01
 */

import { formatDate } from '@/utils/date'
const globalFilters = {}
globalFilters.install = (Vue) => {
    // 自定义格式化时间
    Vue.filter('formatTime', function(value, type) {
        if (value) {
            return formatDate(new Date(value), type)
        }
    })

    Vue.filter('substr', function(input, num) {
        if (input !== null && input !== undefined) {
            // console.log(input)
            // console.log(input.length)
            if (input.length > num) {
                input = input.substring(0, num) + '...'
            }
        }
        return input
    })
    Vue.filter('imgSplit', function(input, num) {
         if(num){
            return input.split(',')[num-1]
         }
        return input.split(',') 
    })
    Vue.filter('formatMobile', function(value) {
        if (value !== null && value !== undefined) {
            value = value.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
        }
        return value
    })

    Vue.filter('idNumberToStar', function(value) {
        if (value !== null) {
            var str = String(value)
            var reg = str.slice(-13, -4)
            return str.replace(reg, '****')
        }
    })
    Vue.filter('listToStr', function(value) {
        if (value.length > 0) {
            var str = value.join(',')
            return str
        }
    })
    Vue.filter('splitStr', function(value) {
            if (value !== null && value !== undefined) {
                value = value.split('@')
                return value
            }
        })
        /**
         * 音频秒数转为MM::ss格式
         */
    Vue.filter('audiotime', (value = 0) => {
        var min = Math.floor(value / 60)
        min = min < 10 ? '0' + min : min
        var sec = Math.floor(value % 60)
        sec = sec < 10 ? '0' + sec : sec
        return min + ':' + sec
    })
}

export default globalFilters


// WEBPACK FOOTER //
// ./src/filters/index.js